import { Application } from "@hotwired/stimulus"
import { ensureBusinessConstants } from "../lib/business_constants_fallback"

ensureBusinessConstants()

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
